var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.mask)?_c('TextField',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"value":_vm.initial_value},on:{"input":_vm.on_input}},'TextField',_vm.$attrs,false)):_c('TextField',_vm._g(_vm._b({},'TextField',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }